import { _, ts } from '_core';

// prepareRiskFactorExposureData
const transform = (
  data: ts.types.widgets.TableData,
  tab: 'risk_factor' | 'industries' | 'other',
  riskModel?: ts.types.riskModel.RiskModel
) => {
  const riskFactorCols = ['specific_risk'];
  const riskStyleFactors = riskModel?.definition.style || [];

  const newData = data?.map((item) => {
    const newItem = { date: item.date } as ts.types.widgets.TableData[number];
    Object.keys(item).forEach((key) => {
      if (key !== 'date') {
        if (tab == 'industries' && key.startsWith('_industry_')) newItem[key.replace('_industry_', '')] = item[key];
        if (tab == 'risk_factor' && riskFactorCols.includes(key)) newItem['Specific Risk'] = item[key];
        if (tab == 'other' && !riskFactorCols.includes(key) && !key.startsWith('_industry_')) {
          const newHandle = key.replace('_handle_', '');
          const styleFactorName = riskStyleFactors.find((rf) => rf.handle == newHandle)?.name || _.startCase(newHandle);
          newItem[styleFactorName] = item[key];
        }
      }
    });
    return newItem;
  });

  return newData;
};

export { transform };
